import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Typography } from "antd";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import UnitSelectbox from "../../unit/UnitSelectbox";
import { useCalendar } from "./CalendarContext";
import { t } from "i18next";
import { isMobile } from 'react-device-detect'
import ApiService from "../../../core/service/ApiService";
import locale from 'antd/es/date-picker/locale/tr_TR';
import Helper from "../../../core/Helper";
import { CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";


export default function AppointmentFilter({ }) {
    const { filter, units, setUnits, setDate, setSelectedUnits, setSearchText, setHideDeletedAndCancelled } = useCalendar();

    const load = async () => {
        const res = await ApiService.Unit.GetUnitList();
        if (res.success) {
            setUnits(res.data)
        }
    }

    useEffect(() => {
        load()
    }, [])

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 8,
                    alignItems: 'start'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'start', width: '100%', flexWrap: 'wrap' }}>
                    <Select
                        // allowClear={true}
                        onChange={(values) => setSelectedUnits(values)}
                        mode="tags"
                        maxTagCount={isMobile ? 'responsive' : 5}
                        value={filter.selectedUnits}
                        style={{ minWidth: 300 }}
                        placeholder={t('Units')}
                        virtual={false}
                    >
                        {
                            units.map(u => {
                                return (
                                    <Select.Option value={u.id} key={u.id}>
                                        <b>{u?.firm?.name}</b> -{u.name}
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>
                    {
                        isMobile && (
                            <>

                            </>
                        )
                    }
                    <div style={{ padding: '4px 10px' }}>
                        <Checkbox
                            checked={filter.hideDeletedAndCancelled}
                            onChange={(e) => setHideDeletedAndCancelled(e.target.checked)}
                        >
                            {t('Silinen ve İptal Edilenleri Gizle')}
                        </Checkbox>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            gap: 4,
                            flexWrap: 'wrap'
                        }}
                    >
                        <DatePicker
                            locale={Helper.Date.getLocale()}
                            value={filter.date}
                            format={'DD/MM/yyyy, dddd'}
                            style={{ minWidth: 200, height: 28 }}
                            onChange={(val) => setDate(val)}
                        />
                        <Button
                            onClick={
                                () => { setDate(moment(filter.date).add(-1, 'days')) }
                            }
                        >
                            {'<'}
                        </Button>
                        <Button onClick={() => { setDate(moment(filter.date).add(1, 'days')) }}>{'>'}</Button>
                        <Button type={'primary'} onClick={() => { setDate(moment()) }}>{t('Today')}</Button>
                    </div>
                </div>
            </div>
        </>
    )
}